import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactActionsService {
  private readonly openMessage$ = new Subject<void>();
  private readonly toggleWechat$ = new Subject<void>();

  readonly onOpenMessage = this.openMessage$.asObservable();
  readonly onToggleWechat = this.toggleWechat$.asObservable();

  openMessageDialog(): void {
    this.openMessage$.next();
  }

  toggleWechatQR(): void {
    this.toggleWechat$.next();
  }
}
